import React, { useState, useEffect } from 'react';
import SelecionarCategoria from '../Utils/SelecionarCategoria';
import { Form, InputGroup, Button, Card, Alert, Col} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';

const DespesaForm = () => {
    const navigate = useNavigate();
    const { id, tipo} = useParams();
    const [categoriaId, setCategoriaId] = useState(null);
    const [financeiro, setFinanceiro] = useState(null);
    const [formErrors, setFormErrors] = useState([]);
    const { 
      setLinks, 
      setBtns,
      crudAdmin,
    } = useProvider();
    const { patch, post, get, del, loading } = crudAdmin || {};
    const formData = new FormData();


    const handleDelete = () => {
      Swal.fire({
        title: "Tem certeza em excluir?",
        text: "Esta ação é definitiva, não poderá ser revertida.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await del(`/financas/financeiros/${id}/`);
            navigate(-1);
            Toast.fire({
                icon: "success",
                title: 'Despesa excluída com sucesso'
            });
          }catch(err){
            validarErrosApi(err);
          }
        }
      });
    }
    

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
            ...(id ? [{ icon: 'bi-trash', onClick: handleDelete }] : []),
            { icon: 'bi-check-lg', onClick: handleSubmit }
        ]);
    
        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, financeiro, categoriaId, setLinks, id]); // Dependências ajustadas
    // Carrega o categorias ao editar
    useEffect(() => {
      if (id){
        carregarFinanceiros();
      }else{
        setFinanceiro((prevItem) => ({
          ...prevItem,
          pago: true,
          data: new Date().toLocaleDateString('sv-SE'),
        }));
      }
    }, [id]);
    
  

    const carregarFinanceiros = async () => {
        try {
            const response = await get(`/financas/financeiros/${id}/?expand=financeiro_pagamentos`);
            //alert(JSON.stringify(response))
            if (response && response.length) {
                setCategoriaId(response[0]?.categoria);
                setFinanceiro({
                  ...response[0],
                  pago: response[0]?.financeiro_pagamentos[0]?.pago,
                  data: response[0]?.data
                    ? response[0].data.split('/').reverse().join('-')
                    : ''
                });
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        //alert(JSON.stringify(err.response))
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar.' 
            : err.response?.data?.detail;
            
        if(err.response?.data?.detail){
            Toast.fire({
                icon: "error",
                title: err.response?.data?.detail
            });
        }
        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            observacoes: err.response?.data?.observacoes,
            categoria: err.response?.data?.categoria,
            data: err.response?.data?.data,
        }));
    };

    const handleSubmit = async (e) => {
        if(e) e.preventDefault();
        
        const errors = {};
        if (!financeiro?.data) errors.data = 'Por favor, informe uma data';
        if (!financeiro?.valor) errors.valor = 'Por favor, informe um valor';
        // if (!categoriaId) errors.categoriaId = 'Por favor, selecione uma marca/fornecedor.';
        
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        
        setFormErrors({});

        
        formData.append('data', financeiro?.data);
        formData.append('pago', financeiro?.pago);
        formData.append('valor', parseFloat(financeiro?.valor||0));
        formData.append('observacoes', financeiro?.observacoes||``);
        formData.append('categoria', categoriaId||``);
        
        const apiRequest = id ? patch : post;
        try {
            const response = await apiRequest(formData, `/financas/financeiros/${id?id+'/':''}?expand=financeiro_pagamentos`);
            //alert(JSON.stringify(response))
            if (response && response.length) {
                Toast.fire({
                    icon: "success",
                    title: `Salvo com sucesso`
                });
                navigate(-1);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };
    

    return (
        <div className="">
              <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <Form.Group controlId="formValor" className="mt-2">
                          <InputGroup>
                            <span className="input-group-text">Valor</span>
                            <Form.Control 
                                type="number" 
                                value={financeiro?.valor} 
                                onChange={(e) => 
                                    setFinanceiro((prevItem) => ({
                                        ...prevItem,
                                        valor: e.target.value
                                    }))
                                }
                                onBlur={(e) => 
                                    setFinanceiro((prevItem) => ({
                                        ...prevItem,
                                        valor: parseFloat(e.target.value||0).toFixed(2)
                                    }))
                                }
                            />
                          </InputGroup>
                          {formErrors.valor && <Alert variant="danger">{formErrors.valor}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formData" className="mt-2">
                          <InputGroup>
                            <span className="input-group-text">Data</span>
                            <Form.Control 
                                type="date" 
                                value={financeiro?.data} 
                                onChange={(e) => 
                                    setFinanceiro((prevItem) => ({
                                        ...prevItem,
                                        data: e.target.value
                                    }))
                                }
                            />
                          </InputGroup>
                          {formErrors.data && <Alert variant="danger">{formErrors.data}</Alert>}
                        </Form.Group>
                          <Form.Group controlId="formPago" className="mt-2">
                                <Form.Check 
                                    type="switch" 
                                    label="Está pago"
                                    checked={financeiro?.pago} 
                                    onChange={(e) => 
                                        setFinanceiro((prevItem) => ({
                                            ...prevItem,
                                            pago: e.target.checked
                                        }))
                                    }
                                />
                                {formErrors.pago && <Alert variant="danger">{formErrors.pago}</Alert>}
                            </Form.Group>
                        <SelecionarCategoria defaultText={` `} tipo={tipo||`pessoais,negocio`} categoriaId={categoriaId} setCategoriaId={setCategoriaId} label="Categoria"/>
                        {formErrors.categoria && <Alert variant="danger">{formErrors.categoria}</Alert>}
                        <Form.Group controlId="formDescricao" className="mt-2">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={4}
                                value={financeiro?.observacoes || ''} 
                                onChange={(e) => 
                                    setFinanceiro((prevItem) => ({
                                        ...prevItem,
                                        observacoes: e.target.value
                                    }))
                                }
                            />
                            {formErrors.observacoes && <Alert variant="danger">{formErrors.observacoes}</Alert>}
                        </Form.Group>
                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            {loading ? financeiro ? "Salvando..." : 'Carregando...' : 'Salvar alterações'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};


export default DespesaForm;